import { render, staticRenderFns } from "./fccPublicacoesTGrupo.vue?vue&type=template&id=b784cea8"
import script from "./fccPublicacoesTGrupo.vue?vue&type=script&lang=js"
export * from "./fccPublicacoesTGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports